import {SetUserAction} from "../types/types";
import {actionTypes} from "../types/enums";
import {User} from "oidc-client-ts";

let initState:User|null = null;

export const userInfo = (state: User|null = initState, action: SetUserAction): User|null => {
    const { type, payload } = action;
    switch (type) {
        case actionTypes.SET_USER:
            return payload;
        default:
            return state;
    }
};